<template>
<loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
  <SrcBackgroundScroll @scrolled="isShrunk = $event">
    <HeadlineSubScroll 
        :title="this.$store.state.WbLTE ? $t('settings.networklte') : $t('settings.network')" 
        target="/Settings" 
        :hassubline="!isShrunk"
        :hasmenu="false"
        :isShrunk="isShrunk"
        >
          <template #icon>
            <IconNetwork             
              class="transition-all duration-300"
              :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
          </template>
          <template #subline>
            {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
          </template>
    </HeadlineSubScroll>

    <ConfirmLeaveModal
      v-model:show="showLeaveDialog"
      :pendingNavigation="this.leaveDialog"
    />

    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>

    <SettingsBody>
      <template v-slot:formgrid>

          <div v-if="this.$store.state.WbLTE" class="form-group mb-2">
            <div class="mt-2 mb-4 w-full">
              <ToggleWithLabel 
                v-model="ltemode"
                @update:model-value="changelte()"
                :label="$t('setnetwork.lteonoff')"
                :ontext="$t('common.on')"
                :offtext="$t('common.off')"
                @update:modelValue ="onChange"
              />
            </div>
          </div>
          <div v-if="ltemode&&this.lte_status=='DISABLED'" class="form-group mb-2">
          </div>
          <div v-if="ltemode&&this.lte_status!='DISABLED'" class="form-group mb-2">
            <label class="font-medium text-sm text-skin-b-list-mute" for="ActualLTEstatus">{{ $t('setnetwork.ltestatus') }}</label>
            <div class="relative w-full inline-flex self-center">
              <svg v-if="lte_status=='SIM_NOT_INSERTED'||lte_status=='SIM_ERROR'||lte_status=='PIN_ERROR'||lte_status=='PIN2_REQ'||lte_status=='PUK_REQ'||lte_status=='PUK2_REQ'"  
                class="h-12 w-12 absolute ml-1.5 top-1 pointer-events-none p-2 text-skin-b-list-mute" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
                <path d="M479.982-280q14.018 0 23.518-9.482 9.5-9.483 9.5-23.5 0-14.018-9.482-23.518-9.483-9.5-23.5-9.5-14.018 0-23.518 9.482-9.5 9.483-9.5 23.5 0 14.018 9.482 23.518 9.483 9.5 23.5 9.5ZM453-433h60v-253h-60v253Zm27.266 353q-82.734 0-155.5-31.5t-127.266-86q-54.5-54.5-86-127.341Q80-397.681 80-480.5q0-82.819 31.5-155.659Q143-709 197.5-763t127.341-85.5Q397.681-880 480.5-880q82.819 0 155.659 31.5Q709-817 763-763t85.5 127Q880-563 880-480.266q0 82.734-31.5 155.5T763-197.684q-54 54.316-127 86Q563-80 480.266-80Zm.234-60Q622-140 721-239.5t99-241Q820-622 721.188-721 622.375-820 480-820q-141 0-240.5 98.812Q140-622.375 140-480q0 141 99.5 240.5t241 99.5Zm-.5-340Z"/>
              </svg>
              <svg v-if="lte_status=='BOOTING'||lte_status=='CONNECTING'" 
                class="h-12 w-12 absolute ml-1.5 top-1 pointer-events-none p-2 text-skin-b-list-mute" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
                <path d="M266.118-430Q287-430 301.5-444.618q14.5-14.617 14.5-35.5Q316-501 301.382-515.5q-14.617-14.5-35.5-14.5Q245-530 230.5-515.382q-14.5 14.617-14.5 35.5Q216-459 230.618-444.5q14.617 14.5 35.5 14.5Zm214 0Q501-430 515.5-444.618q14.5-14.617 14.5-35.5Q530-501 515.382-515.5q-14.617-14.5-35.5-14.5Q459-530 444.5-515.382q-14.5 14.617-14.5 35.5Q430-459 444.618-444.5q14.617 14.5 35.5 14.5Zm213 0Q714-430 728.5-444.618q14.5-14.617 14.5-35.5Q743-501 728.382-515.5q-14.617-14.5-35.5-14.5Q672-530 657.5-515.382q-14.5 14.617-14.5 35.5Q643-459 657.618-444.5q14.617 14.5 35.5 14.5ZM480.266-80q-82.734 0-155.5-31.5t-127.266-86q-54.5-54.5-86-127.341Q80-397.681 80-480.5q0-82.819 31.5-155.659Q143-709 197.5-763t127.341-85.5Q397.681-880 480.5-880q82.819 0 155.659 31.5Q709-817 763-763t85.5 127Q880-563 880-480.266q0 82.734-31.5 155.5T763-197.684q-54 54.316-127 86Q563-80 480.266-80Zm.234-60Q622-140 721-239.5t99-241Q820-622 721.188-721 622.375-820 480-820q-141 0-240.5 98.812Q140-622.375 140-480q0 141 99.5 240.5t241 99.5Zm-.5-340Z"/>
              </svg>
              <svg v-if="lte_status=='REBOOT_REQ'" 
                class="h-12 w-12 absolute ml-1.5 top-1 pointer-events-none p-2 text-skin-b-list-mute" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
                <path d="m40-120 440-760 440 760H40Zm104-60h672L480-760 144-180Zm340.175-57q12.825 0 21.325-8.675 8.5-8.676 8.5-21.5 0-12.825-8.675-21.325-8.676-8.5-21.5-8.5-12.825 0-21.325 8.675-8.5 8.676-8.5 21.5 0 12.825 8.675 21.325 8.676 8.5 21.5 8.5ZM454-348h60v-224h-60v224Zm26-122Z"/>
              </svg>
              <svg v-if="lte_status=='CONNECTION_OK'" class="h-12 w-12 absolute ml-1.5 top-1 pointer-events-none p-2 text-skin-b-list-mute" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
                <g v-if="lte_signal_quality==5">
                  <rect height="640" rx="20" width="140" x="700" y="-800"/>
                  <rect height="500" rx="20" width="140" x="500" y="-660"/>
                  <rect height="360" rx="20" width="140" x="300" y="-520"/>
                  <rect height="220" rx="20" width="140" x="100" y="-380"/>
                </g>
                <g v-if="lte_signal_quality==4">
                  <rect opacity=".333" height="640" rx="20" width="140" x="700" y="-800"/>
                  <rect height="500" rx="20" width="140" x="500" y="-660"/>
                  <rect height="360" rx="20" width="140" x="300" y="-520"/>
                  <rect height="220" rx="20" width="140" x="100" y="-380"/>
                </g>
                <g v-if="lte_signal_quality==3">
                  <rect opacity=".333" height="640" rx="20" width="140" x="700" y="-800"/>
                  <rect opacity=".333" height="500" rx="20" width="140" x="500" y="-660"/>
                  <rect height="360" rx="20" width="140" x="300" y="-520"/>
                  <rect height="220" rx="20" width="140" x="100" y="-380"/>
                </g>
                <g v-if="lte_signal_quality==2">
                  <rect opacity=".333" height="640" rx="20" width="140" x="700" y="-800"/>
                  <rect opacity=".333" height="500" rx="20" width="140" x="500" y="-660"/>
                  <rect opacity=".333" height="360" rx="20" width="140" x="300" y="-520"/>
                  <rect height="220" rx="20" width="140" x="100" y="-380"/>
                </g>
                <g v-if="lte_signal_quality==1">
                  <rect opacity=".333" height="640" rx="20" width="140" x="700" y="-800"/>
                  <rect opacity=".333" height="500" rx="20" width="140" x="500" y="-660"/>
                  <rect opacity=".333" height="360" rx="20" width="140" x="300" y="-520"/>
                  <rect opacity=".333" height="220" rx="20" width="140" x="100" y="-380"/>
                </g>
                <g v-if="lte_signal_quality==0">
                  <rect height="110" rx="20" width="140" x="700" y="-270"/>
                  <rect height="110" rx="20" width="140" x="500" y="-270"/>
                  <rect height="110" rx="20" width="140" x="300" y="-270"/>
                  <rect height="110" rx="20" width="140" x="100" y="-270"/>
                </g>             
              </svg>
              <input disabled v-model="lte_status_txt" type="text" class="form-control
                mt-1 block w-full px-3 py-2 rounded-lg 
                font-semibold text-lg disabled:text-skin-b-list-mute
                border-2 border-skin-b-list-bord" 
                :class="{ 'bg-skin-b-list-head': lte_status==''||lte_status=='DISABLED',
                          'bg-red-100 pl-14': lte_status=='SIM_NOT_INSERTED'||lte_status=='SIM_ERROR'||lte_status=='PIN_ERROR'||lte_status=='PIN2_REQ'||lte_status=='PUK_REQ'||lte_status=='PUK2_REQ',
                          'bg-orange-100 pl-14': lte_status=='BOOTING'||lte_status=='CONNECTING'||lte_status=='REBOOT_REQ',
                          'bg-green-100 pl-14': lte_status=='CONNECTION_OK' }" 
                name="ActualLTEstatus" id="ActualLTEstatus" ref="ActualLTEstatus"
                aria-describedby="ActualLTEstatus" placeholder="Aktueller Mobilfunk-Status">
            </div>
          </div>    
          <div v-if="ltemode" class="form-group mb-2"> <!-- PIN APN APNuser APNpass -->
            <div class="mt-2 mb-4 w-full">

              <InputLabelError
              v-if="lte_status=='PUK_REQ'||lte_status=='PUK2_REQ'"
              v-model="lte_puk"
              label="slot"
              :placeholder="$t('setnetwork.pukph')"
              @update:modelValue ="onChange"
              >
                <template v-slot:label>
                  <SrcLabel v-if="lte_status=='PUK_REQ'" for="SimPuk">{{ $t('setnetwork.puk') }} <span class="font-bold text-red-600">{{ $t('setnetwork.puk',{count:lte_puk_count},lte_puk_count) }}</span></SrcLabel>
                  <SrcLabel v-if="lte_status=='PUK2_REQ'" for="SimPuk">{{ $t('setnetwork.puk2') }} <span class="font-bold text-red-600">{{ $t('setnetwork.puk',{count:lte_puk_count},lte_puk_count) }}</span></SrcLabel>
                </template>
              </InputLabelError>

              <InputLabelError
              v-model="lte_pin"
              label="slot"
              :placeholder="$t('setnetwork.simpinph')"
              @update:modelValue ="onChange"
              >
                <template v-slot:label>
                  <SrcLabel v-if="lte_status!='PIN_ERROR'&&lte_status!='PIN2_REQ'" for="SimPin">{{ $t('setnetwork.simpin') }}</SrcLabel>
                  <SrcLabel v-if="lte_status=='PIN_ERROR'" for="SimPuk">{{ $t('setnetwork.simpin') }} <span class="font-bold text-red-600">{{ $t('setnetwork.puk',{count:lte_pin_count},lte_pin_count) }}</span></SrcLabel>
                  <SrcLabel v-if="lte_status=='PIN2_REQ'" for="SimPuk">{{ $t('setnetwork.simpin2') }} <span class="font-bold text-red-600">{{ $t('setnetwork.puk',{count:lte_pin_count},lte_pin_count) }}</span></SrcLabel>
                </template>
              </InputLabelError>

                <InputLabelError 
                  v-model="lte_apn"
                  :label="$t('setnetwork.apn')"
                  :placeholder="$t('setnetwork.apnph')"
                  @update:modelValue ="onChange"
                />

                <InputLabelError 
                  v-model="lte_user"
                  :label="$t('setnetwork.apnuser')"
                  placeholder=""
                  @update:modelValue ="onChange"
                />

                <InputLabelError 
                  v-model="lte_pass"
                  :label="$t('setnetwork.apnpass')"
                  placeholder=""
                  @update:modelValue ="onChange"
                />                          
            </div>
          </div>
          <div v-if="this.$store.state.WbLTE" class="form-group">
            <div v-if="ltemode" class="mt-2 mb-4 w-full">
              <ToggleWithLabel 
                @update:model-value="changedhcpserver()"
                v-model="dhcpservermode"
                :label="$t('setnetwork.dhcpserver')"
                :ontext="$t('common.on')"
                :offtext="$t('common.off')"
                @update:modelValue ="onChange"
              />
            </div>
            <div v-if="ltemode&&dhcpservermode" class="form-group">
              <div id="DhcpServerInfo" class="font-semibold text-lg text-skin-b-list-mute bg-skin-b-list-head 
              w-full px-3 py-2 rounded-lg border-2 border-skin-b-list-bord">
              {{ $t('setnetwork.ltedhcptxt') }}
              </div> 
            </div>
            <div v-if="ltemode&&!dhcpservermode" class="mt-2 mb-4 w-full">
              <div :class="{ error: v$.lte_ip.$errors.length }">
                <label class="font-medium text-sm text-skin-b-list-mute" for="lte_Network IP">{{ $t('setnetwork.staticip') }}</label>
                <input :disabled="dhcpservermode" v-model="v$.lte_ip.$model" type="text" class="form-control
                  mt-1 mb-2 block w-full px-3 py-2 rounded-lg 
                  font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
                  border-2 border-skin-b-list-bord 
                  hover:bg-skin-b-list-head
                  focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0 
                  " name="lte_Network IP" id="lte_Network IP" ref="lte_Network IP"
                  aria-describedby="Network IP" :placeholder="$t('setnetwork.staticipph')">
                  <div class="text-xs text-skin-b-list-base mt-2" v-for="(error, index) of v$.lte_ip.$errors" :key="index">
                      <div class="error-msg text-center">{{ error.$message }}</div>
                  </div>                  
              </div>
              <div :class="{ error: v$.lte_subnet.$errors.length }">
                <label class="font-medium text-sm text-skin-b-list-mute" for="lte_Subnetmask">{{ $t('setnetwork.subnet') }}</label>
                <input :disabled="dhcpservermode" v-model="v$.lte_subnet.$model" type="text" class="form-control
                  mt-1 mb-2 block w-full px-3 py-2 rounded-lg 
                  font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
                  border-2 border-skin-b-list-bord 
                  hover:bg-skin-b-list-head
                  focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0 
                  " name="lte_Subnetmask" id="lte_Subnetmask" ref="lte_Subnetmask"
                  aria-describedby="lte_Subnetmask" :placeholder="$t('setnetwork.subnetph')">
                  <div class="text-xs text-skin-b-list-base mt-2" v-for="(error, index) of v$.lte_subnet.$errors" :key="index">
                      <div class="error-msg text-center">{{ error.$message }}</div>
                  </div>                  
              </div>
              <div :class="{ error: v$.lte_gateway.$errors.length }">
                <label class="font-medium text-sm text-skin-b-list-mute" for="lte_Gateway">{{ $t('setnetwork.gateway') }}</label>
                <input :disabled="dhcpservermode" v-model="v$.lte_gateway.$model" type="text" class="form-control
                  mt-1 mb-2 block w-full px-3 py-2 rounded-lg 
                  font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
                  border-2 border-skin-b-list-bord 
                  hover:bg-skin-b-list-head
                  focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0 
                  " name="lte_Gateway" id="lte_Gateway" ref="lte_Gateway"
                  aria-describedby="lte_Gateway" :placeholder="$t('setnetwork.gatewayph')">
                  <div class="text-xs text-skin-b-list-base mt-2" v-for="(error, index) of v$.lte_gateway.$errors" :key="index">
                      <div class="error-msg text-center">{{ error.$message }}</div>
                  </div>                  
              </div>              
            </div>     
          </div>

          <div v-if="!ltemode" class="form-group mb-2">

            <SelectWithLabelIcon
                v-model="selectedNetwork"
                @update:model-value="changeNetwork()"
                :label="$t('setnetwork.internetvia')"    
                @update:modelValue ="onChange"
              >
              <template v-slot:options>
                <option v-for="(network, index) in NetworkTypList" :key="index" :value="index">
                  {{network}}
                </option>
              </template>
            </SelectWithLabelIcon>
          </div>
          <div v-if="!ltemode" class="form-group">
          </div>

          <div v-if="!ltemode&&(selectedNetwork==1||selectedNetwork==2)" class="form-group mb-2">

            <div v-if="selectedNetwork==1">

              <InputLabelError 
                  v-model="wifi_ssid"
                  :label="$t('setnetwork.wifiname')"
                  :placeholder="$t('setnetwork.wifiname')"
                  validationType="filled"
                  @valid="(status) => valid_ssid = status"
                  @update:modelValue ="onChange"
                />

              <label class="font-medium text-sm text-skin-b-list-mute" for="Wifi Password">{{ $t('setnetwork.wifipass') }}</label>
              <div class="flex flex-row">
                <div class="w-full">
                  <input v-if="showWifiPass" v-model="wifi_password" type="text" autocomplete="off" class="form-control
                    mt-1 mb-2 block w-full px-3 py-2 rounded-l-lg
                    font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
                    border-2 border-skin-b-list-bord 
                    hover:bg-skin-b-list-head
                    focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0 
                    " name="Wifi Password" id="Wifi Password" ref="Wifi Password"
                    aria-describedby="Wifi Password" :placeholder="$t('setnetwork.wifipass')" @input ="onChange">
                  <input v-else v-model="wifi_password" type="password" autocomplete="off" class="form-control
                      mt-1 mb-2 block w-full px-3 py-2 rounded-l-lg 
                      font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
                      border-2 border-skin-b-list-bord 
                      hover:bg-skin-b-list-head
                      focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0 
                      " name="Wifi Password" id="Wifi Password" ref="Wifi Password"
                      aria-describedby="Wifi Password" :placeholder="$t('setnetwork.wifipass')" @input ="onChange">
                </div>
                <div class="">
                  <button @click.prevent="submitForm" :disabled="!wifi_password" class="mt-1 px-3 py-2 rounded-r-lg border-r-2 border-y-2 disabled:text-skin-b-list-mute border-skin-b-list-bord hover:bg-skin-b-list-head focus:ring-transparent focus:outline-none focus:ring-0" @click="toggleShow">
                    <svg v-if="showWifiPass" class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" fill="currentColor">
                      <path d="M480.118-330Q551-330 600.5-379.618q49.5-49.617 49.5-120.5Q650-571 600.382-620.5q-49.617-49.5-120.5-49.5Q409-670 359.5-620.382q-49.5 49.617-49.5 120.5Q310-429 359.618-379.5q49.617 49.5 120.5 49.5Zm-.353-58Q433-388 400.5-420.735q-32.5-32.736-32.5-79.5Q368-547 400.735-579.5q32.736-32.5 79.5-32.5Q527-612 559.5-579.265q32.5 32.736 32.5 79.5Q592-453 559.265-420.5q-32.736 32.5-79.5 32.5ZM480-200q-146 0-264-83T40-500q58-134 176-217t264-83q146 0 264 83t176 217q-58 134-176 217t-264 83Z"/>
                    </svg>
                    <svg v-if="!showWifiPass" class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" fill="currentColor">
                      <path d="M816-64 648-229q-35 14-79 21.5t-89 7.5q-146 0-265-81.5T40-500q20-52 55.5-101.5T182-696L56-822l42-43 757 757-39 44ZM480-330q14 0 30-2.5t27-7.5L320-557q-5 12-7.5 27t-2.5 30q0 72 50 121t120 49Zm278 40L629-419q10-16 15.5-37.5T650-500q0-71-49.5-120.5T480-670q-22 0-43 5t-38 16L289-760q35-16 89.5-28T485-800q143 0 261.5 81.5T920-500q-26 64-67 117t-95 93ZM585-463 443-605q29-11 60-4.5t54 28.5q23 23 32 51.5t-4 66.5Z"/>
                    </svg>
                  </button>
                </div>
              </div>

            </div>

            <div v-if="selectedNetwork==2">
              <InputLabelError 
                  v-model="wifi_ssid"
                  :disabled="true"
                  :label="$t('setnetwork.hotspotname')"
                  :placeholder="$t('setnetwork.hotspotname')"
                  @update:modelValue ="onChange"
                />
            </div>          

          </div>          
      
          <div v-if="!ltemode" class="form-group mb-2">

            <div v-if="selectedNetwork==0||selectedNetwork==1" class="mt-2 mb-4 w-full">
              <ToggleWithLabel 
                v-model="dhcpmode"
                @update:model-value="changedhcp()"
                :label="$t('setnetwork.dhcp')"
                :ontext="$t('common.on')"
                :offtext="$t('common.off')"
                @update:modelValue ="onChange"
              />
            </div>
            <InputLabelError 
              v-model="network_ip"
              :disabled="dhcpmode||selectedNetwork==2"
              :label="$t('setnetwork.ipadress')"
              :placeholder="$t('setnetwork.staticipph')"
              validationType="ip"
              :validator_off="dhcpmode"
              @valid="(status) => valid_ip = status"
              @update:modelValue ="onChange"
            />
            <InputLabelError 
              v-model="network_subnet"
              :disabled="dhcpmode||selectedNetwork==2"
              :label="$t('setnetwork.subnet')"
              :placeholder="$t('setnetwork.subnetph')"
              validationType="subnet"
              :validator_off="dhcpmode"
              @valid="(status) => valid_subnet = status"
              @update:modelValue ="onChange"
            />
            <InputLabelError 
              v-model="network_gateway"
              :disabled="dhcpmode||selectedNetwork==2"
              :label="$t('setnetwork.gateway')"
              :placeholder="$t('setnetwork.gatewayph')"
              validationType="gateway"
              :validator_off="dhcpmode"
              @valid="(status) => valid_gateway = status"
              @update:modelValue ="onChange"
            />
            <InputLabelError 
              v-if="!dhcpmode&&selectedNetwork!=2"
              v-model="network_dns"
              :disabled="dhcpmode||selectedNetwork==2"
              :label="$t('setnetwork.dnsserver')"
              :placeholder="$t('setnetwork.dnsserverph')"
              validationType="dnsserver"
              :validator_off="dhcpmode"
              @valid="(status) => valid_dns = status"
              @update:modelValue ="onChange"
            />
          </div>      

        </template>
        <template v-slot:formbottom>

          <div v-if="!ltemode&&(selectedNetwork==0||selectedNetwork==1)" class="w-full mt-6">
            <ActionButton 
              :disabled="checker || !isDirty"
              @click="saveNetwork()">
                {{ $t('setnetwork.savenetwork') }}
            </ActionButton>
          </div>

          <div v-if="ltemode" class="w-full mt-6">
            <ActionButton 
              :disabled="(!dhcpservermode&&(v$.lte_ip.$invalid||v$.lte_subnet.$invalid||v$.lte_gateway.$invalid))||!this.isDirty"
              @click="saveLte()">
                {{ $t('setnetwork.savemobile') }}
            </ActionButton>
          </div>

          <div v-if="networksaved" class="grid gap-4 sm:grid-cols-2">
            <TextfieldWithLabel
              class="mt-4"
              :text="$t('setnetwork.savenetworktxt')"
            />
            <div class="mt-4 w-full text-right">
              <ActionButton @click="restartmodal=true" color="red" :wfull="false">
                {{ $t('common.restartwallbox') }}
              </ActionButton>
            </div>          
          </div>

          <div v-if="lte_status=='REBOOT_REQ'" class="grid gap-4 sm:grid-cols-2">
            <TextfieldWithLabel
              class="mt-4"
              :text="$t('setnetwork.savemobiletxt')"
            />
            <div class="mt-4 w-full text-right">  
              <ActionButton @click="restartmodal=true" color="red" :wfull="false">
                {{ $t('common.restartwallbox') }}
              </ActionButton>
            </div>          
          </div>

        <div v-if="restartmodal" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <button @click.prevent="submitForm" @click="restartmodal=false" type="button" class="absolute top-3 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                          <span class="sr-only">Close modal</span>
                      </button>
                      <div class="p-6 text-center">
                          <svg aria-hidden="true" class="mx-auto mb-4 w-14 h-14" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                          <h3 class="mb-5 text-lg font-semibold text-gray-500">
                            {{ $t('common.restartquestion') }}</h3>
                            <ActionButton @click="restartmodal=false;restartBox();countermodal=true;restarttimer();" color="red" :wfull="false" :margin="true">
                              {{ $t('common.restartconfirm') }}
                            </ActionButton>
                            <ActionButton @click="restartmodal=false" :wfull="false">
                              {{ $t('common.cancel') }}
                            </ActionButton>
                      </div>
                  </div>
              </div>
          </div>
          <div v-if="countermodal" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <div class="p-6 text-center">
                        <h1 class="mb-5 text-5xl font-semibold">
                            {{counter}} s</h1>
                        <h3 class="mb-5 text-lg font-semibold">
                          {{ $t('common.restartnotice') }}</h3>
                      </div>
                  </div>
              </div>
          </div>

        </template>
    </SettingsBody>
  </SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconNetwork from './icons/IconNetwork.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import ActionButton from './elements/ActionButton.vue'
import InputLabelError from './elements/InputLabelError.vue'
import TextfieldWithLabel from './elements/TextfieldWithLabel.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import SelectWithLabelIcon from './elements/SelectWithLabelIcon.vue'
import SrcLabel from './sources/SrcInputLabel.vue'
import useVuelidate from '@vuelidate/core'
import ConfirmLeaveModal from './elements/ConfirmLeaveModal.vue'
import { required, helpers } from '@vuelidate/validators'
import { useI18n } from 'vue-i18n'

export function validName(name) {
  let validNamePattern = new RegExp("^[0-9,]+(?:[-'\\S][0-9,]+)*$");
  if (validNamePattern.test(name)){
    return true;
  }
  return false;
}
export function validIP(ipadress) {
  let validNamePattern = new RegExp("^((25[0-5]|(2[0-4]|1\\d|[1-9]|)\\d)(\\.(?!$)|$)){4}$");
  if (validNamePattern.test(ipadress)){
    return true;
  }
  return false;
}
export default {
  setup () {
    const { t,d,n } = useI18n()
    return { t,d,n,v$: useVuelidate() }
  }, 
  components: {
      SrcBackgroundScroll, HeadlineSubScroll, IconNetwork,
      SettingsHeader, SettingsBody, ActionButton,
      InputLabelError, TextfieldWithLabel, ToggleWithLabel, SelectWithLabelIcon, ConfirmLeaveModal,
      SrcLabel
    },
    validations() {
    return {
      lte_ip: {
        required: helpers.withMessage('', required), 
        name_validation: {  $validator: validIP,  $message: this.$t('setnetwork.novalidip') },
      },
      lte_subnet: {
        required: helpers.withMessage('', required), 
        name_validation: {   $validator: validIP,  $message: this.$t('setnetwork.novalidsubnet') },
      },
      lte_gateway: {
        required: helpers.withMessage('', required), 
        name_validation: {   $validator: validIP,  $message: this.$t('setnetwork.novalidgateway') },
      },
    }
  },    
  data() {
    return {
          isLoading: false,
          polling: false,
          saveto: this.$store.state.WbId,
          restartmodal: false,
          countermodal: false,
          counter: 120,
          networksaved: false,
          ltesaved: false,

          dhcp_onoff: 0,
          dhcpmode: false,
          network_type: '',
          network_ip: '',
          valid_ip: false,
          network_subnet: '',
          valid_subnet: false,
          network_gateway: '',
          valid_gateway: false,
          network_dns: '',
          valid_dns: false,
          wifi_ssid: '',
          valid_ssid: false,
          wifi_password: '',
          showWifiPass: false,

          lte_onoff: 0,          
          ltemode: false,
          dhcpserver_onoff: 1,          
          dhcpservermode: true,
          lte_ip: '',
          lte_subnet: '',
          lte_gateway: '',

          lte_pin: '',
          lte_apn: '',
          lte_user: '',
          lte_pass: '',

          lte_status: '',
          lte_pin_count: 0,
          lte_puk: '',
          lte_puk_count: 0,

          lte_operator: 'telekom',
          lte_technology: 'LTE',
          lte_signal_quality: 0,

          client_network: [],
          client_lte: [],
          selectedNetwork: 0,
          NetworkTypList: [this.$t('setnetwork.lan'),this.$t('setnetwork.wifi'),this.$t('setnetwork.hotspot')],
          isShrunk: false,

          isDirty:false,
          showLeaveDialog:false
    }
  },
  beforeRouteLeave(to, from, next) {

    if (this.isDirty || this.editmode) {
      this.showLeaveDialog = true;
      this.pendingNavigation = next;    
    } else {
      next();
    }
  },
  computed: {
    checker(){
      if( (this.selectedNetwork==0&&this.dhcpmode)||
          (this.selectedNetwork==0&&!this.dhcpmode&&this.valid_ip&&this.valid_subnet&&this.valid_gateway&&this.valid_dns)||
          (this.selectedNetwork==1&&this.dhcpmode&&this.valid_ssid)||
          (this.selectedNetwork==1&&!this.dhcpmode&&this.valid_ssid&&this.valid_ip&&this.valid_subnet&&this.valid_gateway&&this.valid_dns))
          return false;
        else
          return true;
    },
    ltechecker(){// wenn dhcpserver off checke ip subnet gateway darf nicht leer sein
      if(this.dhcpservermode||(!this.dhcpservermode&&(!this.v$.lte_ip.$invalid||!this.v$.lte_subnet.$invalid||!this.v$.lte_gateway.$invalid)))
          return false;
        else
          return true;
    },
    lte_status_txt(){
      if(this.lte_status=='DISABLED')
        return this.$t('setnetwork.DISABLED');
      else if(this.lte_status=='REBOOT_REQ')
        return this.$t('setnetwork.REBOOT_REQ');
      else if(this.lte_status=='SIM_NOT_INSERTED')
        return this.$t('setnetwork.SIM_NOT_INSERTED');
      else if(this.lte_status=='SIM_ERROR')
        return this.$t('setnetwork.SIM_ERROR');
      else if(this.lte_status=='PIN_ERROR')
        return this.$t('setnetwork.PIN_ERROR');
      else if(this.lte_status=='PIN2_REQ')
        return this.$t('setnetwork.PIN2_REQ');
      else if(this.lte_status=='PUK_REQ')
        return this.$t('setnetwork.PUK_REQ');
      else if(this.lte_status=='PUK2_REQ')
        return this.$t('setnetwork.PUK2_REQ');
      else if(this.lte_status=='BOOTING')
        return this.$t('setnetwork.BOOTING');
      else if(this.lte_status=='CONNECTING')
        return this.$t('setnetwork.CONNECTING');
      else if(this.lte_status=='CONNECTION_OK')
        return this.lte_technology+' • '+this.lte_operator;
      else
        return this.$t('setnetwork.notavailable');
    },
  },
  methods: {
    onChange() {this.isDirty = true;},
    leaveDialog(){this.pendingNavigation();},
    toggleShow() {
      this.showWifiPass = !this.showWifiPass;
    },
    restarttimer() {
        this.interval = setInterval(() => {
          if (this.counter === 0) {
            clearInterval(this.interval);
            this.$router.push({path: '/'});               
          } else {
            this.counter--
          }             
        }, 1000)
    },
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
      },
    changelte(){
      this.networksaved = false;
      this.ltesaved = false;
      if(this.ltemode){
        this.lte_onoff=1;
        this.polling = true;
        this.pollData();  
      }
      else{
        this.lte_onoff=0;
        this.polling = false;       
      }   
    },
    changedhcpserver(){
      this.ltesaved = false;
      if(this.dhcpservermode){
        this.dhcpserver_onoff=1;
        this.lte_ip = '';
        this.lte_subnet = '';
        this.lte_gateway = '';           
      }
      else{
        this.dhcpserver_onoff=0;
        this.lte_ip = this.client_network.ip;
        this.lte_subnet = this.client_network.subnet;
        this.lte_gateway = this.client_network.gateway;       
      }   
    },
    changedhcp(){
      if(this.client_network.typ=='lan'||this.client_network.typ=='wlan'){
        if(this.dhcpmode){
          this.network_ip = this.client_network.ip;
          this.network_subnet = this.client_network.subnet;
          this.network_gateway = this.client_network.gateway;
          this.network_dns = this.client_network.dns;
        }else{
          this.network_ip = '';
          this.network_subnet = '';
          this.network_gateway = '';
          this.network_dns = '';
        }
      }else{
        if(this.dhcpmode){
          this.network_ip = this.$t('setnetwork.fromrouter');
          this.network_subnet = this.$t('setnetwork.fromrouter');
          this.network_gateway = this.$t('setnetwork.fromrouter');
        }else{
          this.network_ip = '';
          this.network_subnet = '';
          this.network_gateway = '';
          this.network_dns = '';
        }
      }
    },  
    changeNetwork(){
      console.log(this.client_network.typ,this.selectedNetwork);
      this.networksaved = false;
      if(this.client_network.typ=='hotspot'&&this.selectedNetwork==2){ //Hotspot && Hotspot
        this.dhcpmode = false;  
        this.network_ip = this.client_network.ip;
        this.network_subnet = this.client_network.subnet;
        this.network_gateway = this.client_network.gateway;
        this.wifi_ssid = this.client_network.ssid;           
      } else if(this.client_network.typ=='hotspot'&&this.selectedNetwork<2){ //Hotspot && LAN/WLAN
        this.dhcpmode = true;  
        this.network_ip = this.$t('setnetwork.fromrouter');
        this.network_subnet = this.$t('setnetwork.fromrouter');
        this.network_gateway = this.$t('setnetwork.fromrouter');
        this.wifi_ssid = '';
        this.wifi_password = '';
      } else if(this.client_network.typ=='lan'&&this.selectedNetwork==0){ //LAN && LAN
        if(this.client_network.dhcp==1)
          this.dhcpmode=true;
        else
          this.dhcpmode=false;  
        this.network_ip = this.client_network.ip;
        this.network_subnet = this.client_network.subnet;
        this.network_gateway = this.client_network.gateway;
        this.wifi_ssid = '';
        this.wifi_password = '';
      } else if(this.client_network.typ=='lan'&&this.selectedNetwork==1){ //LAN && WLAN
        this.dhcpmode=true;
        this.network_ip = this.$t('setnetwork.fromrouter');
        this.network_subnet = this.$t('setnetwork.fromrouter');
        this.network_gateway = this.$t('setnetwork.fromrouter');
        this.wifi_ssid = '';
        this.wifi_password = '';
      } else if(this.client_network.typ=='wlan'&&this.selectedNetwork==1){ //WLAN && WLAN
        if(this.client_network.dhcp==1)
          this.dhcpmode=true;
        else
          this.dhcpmode=false;  
        this.network_ip = this.client_network.ip;
        this.network_subnet = this.client_network.subnet;
        this.network_gateway = this.client_network.gateway;
        this.wifi_ssid = this.client_network.ssid;
        this.wifi_password = '';
      } else if(this.client_network.typ=='wlan'&&this.selectedNetwork==0){ //WLAN && LAN
        this.dhcpmode=true;
        this.network_ip = this.$t('setnetwork.fromrouter');
        this.network_subnet = this.$t('setnetwork.fromrouter');
        this.network_gateway = this.$t('setnetwork.fromrouter');
        this.wifi_ssid = '';
        this.wifi_password = '';
      }
    },
    saveLte() {
      this.isDirty=false;
      if(this.dhcpservermode)
        this.dhcpserver_onoff=1;
      else
        this.dhcpserver_onoff=0;
      if(this.ltemode)
        this.lte_onoff=1;
      else
        this.lte_onoff=0;
      let saveLteUrl = '';
      let eu_lte_apn = encodeURIComponent(this.lte_apn);
      let eu_lte_user = encodeURIComponent(this.lte_user);
      let eu_lte_pass = encodeURIComponent(this.lte_pass);
      let eu_lte_puk = encodeURIComponent(this.lte_puk);
      let eu_lte_pin = encodeURIComponent(this.lte_pin);

      if(this.lte_status=='PUK_REQ'||this.lte_status=='PUK2_REQ'){//PUK benötigt
        if(this.dhcpservermode)
          saveLteUrl = 'wallbox/settings.php?action=sync_network&client='+this.saveto+'&typ=lte'+'&lte_puk='+eu_lte_puk+'&lte_pin='+eu_lte_pin+'&lte_apn='+eu_lte_apn+'&lte_user='+eu_lte_user+'&lte_pass='+eu_lte_pass+'&dhcp_server='+this.dhcpserver_onoff+'&user='+this.$store.state.token;
        else
          saveLteUrl = 'wallbox/settings.php?action=sync_network&client='+this.saveto+'&typ=lte'+'&lte_puk='+eu_lte_puk+'&lte_pin='+eu_lte_pin+'&lte_apn='+eu_lte_apn+'&lte_user='+eu_lte_user+'&lte_pass='+eu_lte_pass+'&dhcp_server='+this.dhcpserver_onoff+'&ip='+this.lte_ip+'&subnet='+this.lte_subnet+'&gateway='+this.lte_gateway+'&user='+this.$store.state.token;
      }else{//normal
        if(this.dhcpservermode)
          saveLteUrl = 'wallbox/settings.php?action=sync_network&client='+this.saveto+'&typ=lte'+'&lte_pin='+eu_lte_pin+'&lte_apn='+eu_lte_apn+'&lte_user='+eu_lte_user+'&lte_pass='+eu_lte_pass+'&dhcp_server='+this.dhcpserver_onoff+'&user='+this.$store.state.token;
        else
          saveLteUrl = 'wallbox/settings.php?action=sync_network&client='+this.saveto+'&typ=lte'+'&lte_pin='+eu_lte_pin+'&lte_apn='+eu_lte_apn+'&lte_user='+eu_lte_user+'&lte_pass='+eu_lte_pass+'&dhcp_server='+this.dhcpserver_onoff+'&ip='+this.lte_ip+'&subnet='+this.lte_subnet+'&gateway='+this.lte_gateway+'&user='+this.$store.state.token;
      }
      this.axios
      .get(saveLteUrl)
      .then((response) => {         
                  if(response.data.status=='ok'){
                    this.ltesaved = true;
                    console.log('LTE gespeichert');
                  }else{
                    console.log('Error save LTE');                   
                  }
                })
                .catch((errors) => {
                    console.log(errors); // Errors
                });
    },
    saveNetwork() {
      this.isDirty=false;
      if(this.dhcpmode)
        this.dhcp_onoff=1;
      else
        this.dhcp_onoff=0;
      let saveNetworkUrl = '';
      let eu_wifi_ssid = encodeURIComponent(this.wifi_ssid);
      let eu_wifi_password = encodeURIComponent(this.wifi_password);

      if(this.selectedNetwork==0){//LAN
        if(this.dhcpmode)
          saveNetworkUrl = 'wallbox/settings.php?action=sync_network&client='+this.saveto+'&typ=lan&dhcp='+this.dhcp_onoff+'&user='+this.$store.state.token;
        else
          saveNetworkUrl = 'wallbox/settings.php?action=sync_network&client='+this.saveto+'&typ=lan&dhcp='+this.dhcp_onoff+'&ip='+this.network_ip+'&subnet='+this.network_subnet+'&gateway='+this.network_gateway+'&dns_server='+this.network_dns+'&user='+this.$store.state.token;
      }else{//WLAN     
        if(this.dhcpmode)
          saveNetworkUrl = 'wallbox/settings.php?action=sync_network&client='+this.saveto+'&typ=wlan&ssid='+eu_wifi_ssid+'&pass='+eu_wifi_password+'&dhcp='+this.dhcp_onoff+'&user='+this.$store.state.token;
        else
          saveNetworkUrl = 'wallbox/settings.php?action=sync_network&client='+this.saveto+'&typ=wlan&ssid='+eu_wifi_ssid+'&pass='+eu_wifi_password+'&dhcp='+this.dhcp_onoff+'&ip='+this.network_ip+'&subnet='+this.network_subnet+'&gateway='+this.network_gateway+'&dns_server='+this.network_dns+'&user='+this.$store.state.token;
      }
      this.axios
      .get(saveNetworkUrl)
      .then((response) => {         
                  if(response.data.status=='ok'){
                    this.networksaved = true;
                    console.log('Network gespeichert');
                  }else{
                    console.log('Error save Network LAN');                   
                  }
                })
                .catch((errors) => {
                    console.log(errors); // Errors
                });
    },
    restartBox(){
      this.axios
              .get('wallbox/client.php?action=reboot&user='+this.$store.state.token+'&id='+this.saveto)
              .then((response) => {         
                          if(response.data.status=='ok'){
                            console.log('Restart der Wallbox');
                          }else{
                            console.log('Error send reboot command');                   
                          }
                        })
              .catch((errors) => {
                console.log(errors); // Errors
              });
    },
    pollData () {
        if(this.polling){
          console.log('get Polldata LTE Status');
          this.axios
          .get('wallbox/info.php?action=get_lte&user='+this.$store.state.token+'&client='+this.$store.state.WbId)
          .then((response) => {         
                      if(response.data.status=='ok'){
                        this.client_lte = response.data.tbl_lte;
                        this.lte_status = this.client_lte.lteStatus;
                        this.lte_pin_count = this.client_lte.lteSimCount;
                        //this.lte_puk = this.client_lte.ltePuk;
                        this.lte_puk_count = this.client_lte.ltePukCount;

                        this.lte_operator = this.client_lte.lteOpertor;
                        this.lte_technology = this.client_lte.lteTechnology;
                        this.lte_signal_quality = this.client_lte.lteQuality;
                        (response.data.status!='') ? setTimeout(() => {  this.execpoll(this.polling); }, 1000) : null
                      }else{
                        console.log('Error get LTE poll data');                   
                      }
                    })
          .catch((errors) => {
              console.log(errors); // Errors
              this.execpoll(this.polling);
                    });
        }
    },    
    execpoll(polling){
        if(polling){
        this.pollData();        
        }
    }   
  },
  beforeUnmount() {
    this.polling=false;
  },
  created() {  
      this.isLoading = true;
      let client_networkUrl = 'wallbox/info.php?action=get_network&user='+this.$store.state.token+'&client='+this.$store.state.WbId;
      let client_lteUrl = 'wallbox/info.php?action=get_lte&user='+this.$store.state.token+'&client='+this.$store.state.WbId;
      const requestclient_network = this.axios.get(client_networkUrl);
      const requestclient_lte = this.axios.get(client_lteUrl);
      this.axios
          .all([requestclient_network,requestclient_lte])
          .then(
              this.axios.spread((...responses) => {
                  const responseclient_network = responses[0];
                  const responseclient_lte = responses[1];

                  if(responseclient_network.data.status=='token'){
                        this.$router.push({path: '/'});             
                  }else if(responseclient_network.data.status=='ok'){
                    this.client_network = responseclient_network.data.tbl_networksettings;
                    //console.log(this.client_network);
                    if(this.client_network.typ=='lan'){
                      this.selectedNetwork = 0;
                      //if(this.client_network.lte_enabled==0,1)
                      this.NetworkTypList = [this.$t('setnetwork.lan'),this.$t('setnetwork.wifi')];                    
                    }
                    if(this.client_network.typ=='wlan'){
                      this.selectedNetwork = 1;
                      this.NetworkTypList = [this.$t('setnetwork.lan'),this.$t('setnetwork.wifi')];
                      //wlan passwort abfragen
                    }
                    if(this.client_network.typ=='lte'){
                      this.selectedNetwork = 0;
                      this.NetworkTypList = [this.$t('setnetwork.lan'),this.$t('setnetwork.wifi')];
                      //wlan passwort abfragen
                    }              
                    if(this.client_network.typ=='hotspot')
                      this.selectedNetwork = 2;

                    this.dhcp_onoff = this.client_network.dhcp;
                    this.dhcpserver_onoff = this.client_network.dhcpServer;
                    this.network_ip = this.client_network.ip;
                    if(this.network_ip!='') this.valid_ip=true;
                    this.network_subnet = this.client_network.subnet;
                    if(this.network_subnet!='') this.valid_subnet=true;
                    this.network_gateway = this.client_network.gateway;
                    if(this.network_gateway!='') this.valid_gateway=true;
                    this.network_dns = this.client_network.dns;
                    if(this.network_dns!='') this.valid_dns=true;
                    this.wifi_ssid = this.decodeHtml(this.client_network.ssid);
                    if(this.wifi_ssid!='') this.valid_ssid=true;
                    this.wifi_password = this.decodeHtml(this.client_network.pass);
                    this.lte_onoff = this.client_network.lte_enabled;
                    this.lte_pin = this.client_network.lte_pin;
                    this.lte_apn = this.decodeHtml(this.client_network.lte_apn);
                    this.lte_user = this.decodeHtml(this.client_network.lte_user);
                    this.lte_pass = this.decodeHtml(this.client_network.lte_pass);             
                    if(this.dhcp_onoff==1)
                      this.dhcpmode=true;
                    else
                      this.dhcpmode=false;
                    if(this.dhcpserver_onoff==1){
                      this.dhcpservermode=true;                      
                    }
                    else{
                      this.dhcpservermode=false;
                      this.lte_ip = this.client_network.ip;
                      this.lte_subnet = this.client_network.subnet;
                      this.lte_gateway = this.client_network.gateway;                    
                    }

                    if(this.lte_onoff==1)
                      this.ltemode=true;
                    else
                      this.ltemode=false;//false
                  }else{
                    console.log('Error get Client Network Table');
                  }

                  if(responseclient_lte.data.status=='token'){
                        this.$router.push({path: '/'});             
                  }else if(responseclient_lte.data.status=='ok'){
                    this.client_lte = responseclient_lte.data.tbl_lte;
                    this.lte_status = this.client_lte.lteStatus;
                    this.lte_pin_count = this.client_lte.lteSimCount;
                    this.lte_puk = this.client_lte.ltePuk;
                    this.lte_puk_count = this.client_lte.ltePukCount;

                    this.lte_operator = this.client_lte.lteOpertor;
                    this.lte_technology = this.client_lte.lteTechnology;
                    this.lte_signal_quality = this.client_lte.lteQuality;
                    if(this.ltemode){
                      this.polling = true;
                      this.pollData();
                    }else{
                      this.polling = false;
                    }
                  }else{
                    console.log('Error get Client LTE Table');
                  }                  

              this.isLoading = false;
              })
          )
          .catch((errors) => {
              this.isLoading = false;
              console.error(errors);
          });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="@vueform/toggle/themes/default.css"></style>
<style scoped>
</style>
